export default interface TipoEndereco {
  valor: string;
  descricao: string;
}

export const RESIDENCIAL: TipoEndereco = {
  valor: "RESIDENCIAL",
  descricao: "Residencial",
};

export const tiposEndereco: TipoEndereco[] = [
  RESIDENCIAL,
  { valor: "COMERCIAL", descricao: "Comercial" },
  { valor: "OUTRO", descricao: "Outros" },
];
